import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Tab, Theme } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { CustomTelInput } from '../../common/CustomTelInput/CustomInput';
import { LoginTabMethodProps } from './types';

export const LoginTabMethod: React.FC<LoginTabMethodProps> = ({
  values,
  setFieldTouched,
  errors,
  touched,
  handleChangePhone,
  onTabChange,
}) => {
  const [signInMethod, setSignInMethod] = useState('1');

  const { t } = useTranslation();

  const handleSetSignInMethod = (
    _event: React.SyntheticEvent,
    newValue: string,
  ) => {
    setSignInMethod(newValue);
    if (onTabChange) {
      onTabChange(newValue);
    }
  };

  return (
    <TabContext value={signInMethod}>
      <Box
        sx={(theme: Theme) => ({
          borderBottom: 1,
          borderColor: theme.palette.common.white,
        })}
      >
        <TabList
          onChange={handleSetSignInMethod}
          sx={(theme: Theme) => ({
            '& .MuiTabs-indicator': {
              backgroundColor: theme.palette.common.white,
            },
          })}
        >
          <Tab
            label={`${t('userAuth.phonePlaceholder')}`}
            value="1"
            sx={(theme: Theme) => ({
              fontFamily: 'inherit',
              color: theme.palette.common.white,
              '&.Mui-selected': {
                color: theme.palette.green.main,
              },
            })}
            disableFocusRipple
            disableTouchRipple
          />
        </TabList>
      </Box>
      <TabPanel
        value="1"
        sx={() => ({
          '&.MuiTabPanel-root': {
            padding: '20px 0 0 0',
          },
        })}
      >
        <CustomTelInput
          fieldName={'phone'}
          label={t('userAuth.phonePlaceholder')}
          value={values.phone}
          onChange={(value) => {
            setFieldTouched('phone');
            handleChangePhone(value);
          }}
          error={touched['phone'] && errors.phone}
        />
      </TabPanel>
    </TabContext>
  );
};
